import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { rootReducer, rootSaga } from './root';

// disable thunk and add redux-saga middleware
const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => {
    return [...getDefaultMiddleware({ thunk: false }), sagaMiddleware];
  },
});

sagaMiddleware.run(rootSaga);

export default store;
